import { Box, CircularProgress, Typography } from "@mui/material";
import { InfoSection } from "../shared/InfoSection";
import { useAlternateAliasSections } from "./useAlternateAliasSections";

const WSU_RED = "#A60F2D";

// Past this length, a value wraps into enough lines at the base tile width
// that giving the tile a second column reads much better.
const WIDE_TILE_THRESHOLD = 60;
const spanFor = (maxLength) => (maxLength > WIDE_TILE_THRESHOLD ? 2 : 1);

export const AlternateAliasDetailPanel = () => {
    const { isLoaded, error, tiles } = useAlternateAliasSections();

    if (!isLoaded) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
                <CircularProgress style={{ color: WSU_RED }} size={80} thickness={5} />
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ backgroundColor: WSU_RED, color: "white", px: 3, py: 2, borderRadius: 2 }}>
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5 }}>Failed to load alias</Typography>
                <Typography variant="body2">{error.message || "Unknown error occurred"}</Typography>
            </Box>
        );
    }

    // Widest/longest tiles are placed first so the dense grid packs the
    // remaining, narrower tiles into the gaps they'd otherwise leave behind.
    const sortedTiles = [...tiles].sort((a, b) => b.maxLength - a.maxLength);

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                gridAutoFlow: "dense",
                gap: 3,
                alignItems: "start",
                width: "100%",
            }}
        >
            {sortedTiles.map((tile) => (
                <InfoSection key={tile.key} heading={tile.heading} rows={tile.rows} span={spanFor(tile.maxLength)} />
            ))}
        </Box>
    );
};
